<template>
  <div class="consult">
    <div class="header">
      <div class="header_bg">
        <img src="../assets/img/header_bg1.png" alt="" />
      </div>
      <div class="header_logo" @click="goHome"></div>
      <div class="header_user_info">
        <div class="header_user_img">
          <img :src="userInfo.avatar" />
        </div>
        <div class="header_user_name">HI，{{ userInfo.nickname }}</div>
        <div class="header_user_center" @click="userCenterClick">个人中心</div>
        <div class="header_user_line">|</div>
        <div class="header_user_exit" @click="logoutClick">退出登录</div>
      </div>
      <div class="header_option">
        <span @click="headerOptionClick(-1)">首页</span>
        <span @click="headerOptionClick(0)">量表测评</span>
        <span @click="headerOptionClick(1)">心理咨询</span>
        <span @click="headerOptionClick(2)">名师课程</span>
        <span @click="headerOptionClick(3)">在线商城</span>
        <span @click="headerOptionClick(4)">共享咨询室</span>
        <span @click="headerOptionClick(5)">员工关爱方案</span>
      </div>
    </div>
    <div style="width: 1200px; margin: 50px auto; min-height: 500px">
      <el-tabs
        v-model="params.order_status"
        type="card"
        @tab-click="handleClick"
      >
        <el-tab-pane :label="stayPayCount" name="0"></el-tab-pane>
        <el-tab-pane :label="stayDeliverCount" name="1"></el-tab-pane>
        <el-tab-pane :label="stayReceiveCount" name="2"></el-tab-pane>
        <el-tab-pane :label="completeCount" name="3"></el-tab-pane>
        <el-tab-pane label="全部" name="1000"> </el-tab-pane>
      </el-tabs>
      <div>
        <ul
          class="consult_list"
          v-infinite-scroll="load"
          :infinite-scroll-disabled="disabled"
          style="overflow: auto"
        >
          <li
            class="consult_list_item"
            v-for="i in shoppingList"
            :key="i.order_sn"
          >
            <div class="item_order_sn_bg">
              <span class="item_order_sn">订单号：{{ i.order_sn }}</span>
              <span class="item_status">{{ i.order_status_msg }}</span>
            </div>
            <div class="item_avatar_bg">
              <el-image
                class="item_avatar_image"
                :src="i.item && i.item.img_url"
                fit="cover"
                @click="consultItemClick(i.item.item_id)"
              ></el-image>
              <div
                class="item_goods_info"
                @click="consultItemClick(i.item.item_id)"
              >
                <div class="item_goods_name">{{ i.item.goods_name }}</div>
                <div class="item_goods_price">￥{{ i.item.price }}</div>
              </div>
              <div class="item_goods_num">商品数量：{{ i.item.quantity }}</div>
              <div class="item_goods_total">￥{{ i.goods_amount }}</div>
              <div class="item_btn_bg">
                <el-button
                  size="mini"
                  type="primary"
                  @click="lookoverOrder(i.order_sn)"
                  >查看订单</el-button
                >
                <el-button
                  v-if="i.order_status == '0'"
                  size="mini"
                  type="danger"
                  @click="goToPay(i.order_sn)"
                  >重新支付</el-button
                >
                <el-button
                  v-if="i.order_status == '0'"
                  size="mini"
                  type="info"
                  @click="cancelOrderClick(i.order_sn)"
                  >取消订单</el-button
                >
                <el-button
                  v-if="i.order_status == '2'"
                  size="mini"
                  type="danger"
                  @click="stayReceive(i.order_sn)"
                  >确认收货</el-button
                >
              </div>
            </div>
          </li>
        </ul>
        <p v-if="loading" class="load_footer">加载中...</p>
        <p v-if="noMore" class="load_footer">没有更多了</p>
      </div>
    </div>

    <copy-footer class="footer" />
    <!-- 重新支付二维码 -->
    <el-dialog title="扫码重新支付" v-model="codeDialogFormVisible" center>
      <div class="qrcode" ref="qrCodeUrl"></div>
      <template #footer>
        <span class="dialog-footer">
          <el-button type="primary" @click="codeDialogFormVisible = false"
            >完 成</el-button
          >
        </span>
      </template>
    </el-dialog>
  </div>
</template>
<script>
import CopyFooter from "../components/footer/CopyFooter.vue";
import {
  item_orders,
  item_order_post_re_payment,
  item_order_post_cancel_order,
  item_order_confirm_receipt,
} from "../network/views-request";
import QRCode from "qrcodejs2";
export default {
  name: "consult",
  components: { CopyFooter },
  props: {},
  data() {
    return {
      userInfo: {},
      params: {
        index: 0,
        count: 20,
        order_status: "0", //订单状态 0:未付款 1:已付款 2:已发货 3:确认收货
      },
      shoppingList: [],
      loading: false,
      allCount: 1000,
      stay_pay_count: 0, //待付款订单数
      stay_deliver_count: 0, //待发货订单数
      stay_receive_count: 0, //待收获订单数
      complete_count: 0, //已完成订单数

      codeDialogFormVisible: false, //重新支付弹窗
      code_url: "", //支付二维码
    };
  },
  computed: {
    noMore() {
      return this.allCount <= this.shoppingList.length;
    },
    disabled() {
      return this.loading || this.noMore;
    },
    stayPayCount() {
      return "待付款（" + this.stay_pay_count + ")";
    },
    stayDeliverCount() {
      return "待发货（" + this.stay_deliver_count + ")";
    },
    stayReceiveCount() {
      return "待收货（" + this.stay_receive_count + ")";
    },
    completeCount() {
      return "已完成（" + this.complete_count + ")";
    },
  },
  created() {
    const info = JSON.parse(localStorage.getItem("userInfo"));
    if (info) {
      this.userInfo = info;
    }
    this.getList();
  },
  methods: {
    //退出登录
    logoutClick() {
      localStorage.clear();
      this.$router.push({ path: "/" });
    },
    //个人中心
    userCenterClick() {
      this.$router.push({ path: "/usercenter" });
    },
    //回主页
    goHome() {
      this.$router.push({ path: "/" });
    },
    headerOptionClick(index) {
      if (index == 0) {
        this.$router.push({ path: "/survey" });
      } else if (index == 1) {
        this.$router.push({ path: "/consult" });
      } else if (index == 2) {
        this.$router.push({ path: "/course" });
      } else if (index == 3) {
        this.$router.push({ path: "/shopping" });
      } else if (index == 4) {
        this.$router.push({ path: "/room" });
      } else if (index == 5) {
        this.$router.push({ path: "/concern" });
      } else {
        this.goHome();
      }
    },
    //点击分类
    handleClick(tab, event) {
      this.params.index = 1;
      this.shoppingList = [];
      this.getList();
    },
    //查看订单
    lookoverOrder(order_sn) {
      this.$router.push({ path: "/shoppingorderdetail", query: { order_sn } });
    },
    //商城订单列表
    getList() {
      this.loading = true;
      item_orders(this.params).then((res) => {
        if (res.code == 200) {
          this.allCount = res.data.all_count;
          this.stay_pay_count = res.data.stay_pay_count;
          this.stay_assess_count = res.data.stay_assess_count;
          this.complete_count = res.data.complete_count;
          this.shoppingList = this.shoppingList.concat(res.data.list);
        } else {
          this.$message.error(res.message);
        }
        this.loading = false;
      });
    },
    load() {
      this.params.index += 1;
      this.getList();
    },
    //点击商品
    consultItemClick(item_id) {
      this.$router.push({ path: "/shoppingdetail", query: { id: item_id } });
    },
    //重新支付
    goToPay(order_sn) {
      this.codeDialogFormVisible = true;
      let data = {
        order_sn,
      };
      item_order_post_re_payment(data).then((res) => {
        if (res.code == 200) {
          this.code_url = res.data.code_url;
          this.creatQrCode(res.data.code_url);
        } else {
          this.$message.error(res.message);
        }
      });
    },
    //生成二维码
    creatQrCode(code_url) {
      let dom = this.$refs.qrCodeUrl;
      while (dom.firstChild) {
        dom.removeChild(dom.firstChild);
      }
      var qrcode = new QRCode(this.$refs.qrCodeUrl, {
        text: code_url, // 需要转换为二维码的内容
        width: 150,
        height: 150,
        colorDark: "#000000",
        colorLight: "#ffffff",
        correctLevel: QRCode.CorrectLevel.H,
      });
    },
    //取消订单
    cancelOrderClick(order_sn) {
      item_order_post_cancel_order({ order_sn }).then((res) => {
        if (res.code == 200) {
          this.$message.success("取消成功");
          this.params.index = 1;
          this.shoppingList = [];
          this.getList();
        } else {
          this.$message.error(res.message);
        }
      });
    },
    //待收货
    stayReceive(order_sn) {
      item_order_confirm_receipt({ order_sn }).then((res) => {
        if (res.code == 200) {
          this.$message.success("已确认收货");
          this.params.index = 1;
          this.shoppingList = [];
          this.getList();
        } else {
          this.$message.error(res.message);
        }
      });
    },
  },
};
</script>
<style scoped>
.header {
  position: relative;
}
.header_logo {
  position: absolute;
  left: 0;
  top: 0;
  width: 25%;
  height: 100%;
  cursor: pointer;
}
.header_user_info {
  position: absolute;
  display: flex;
  align-items: center;
  right: 20px;
  top: 15px;
}
.header_user_img {
  width: 30px;
  height: 30px;
  border-radius: 15px;
  background-color: #fff;
  overflow: hidden;
}
.header_user_img img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.header_user_name {
  margin-left: 10px;
  font-size: 15px;
  color: #fff;
}
.header_user_center {
  margin-left: 15px;
  font-size: 15px;
  color: #fff;
  text-decoration: underline;
  cursor: pointer;
}
.header_user_line {
  margin: 0 15px;
  font-size: 15px;
  color: #fff;
}
.header_user_exit {
  font-size: 15px;
  color: #fff;
  cursor: pointer;
}

.header_option {
  position: absolute;
  right: 0px;
  bottom: 15px;
}
.header_option span {
  padding: 0 20px;
  border-right: 1px solid #fff;
  font-size: 17px;
  flex-wrap: 600;
  color: #fff;
  cursor: pointer;
}
.header_option span:nth-child(6) {
  border-right: 0px solid #fff;
}
.consult_title {
  margin-top: 50px;
  text-align: center;
  font-size: 19px;
  font-weight: 600;
}
.consult_list_item {
  border: 1px solid #ebeef5;
  margin-bottom: 20px;
}
.item_order_sn_bg {
  padding: 10px;
  background-color: rgb(206, 228, 238);
}
.item_order_sn {
  font-size: 15px;
}
.item_order_time {
  margin-left: 20px;
  font-size: 15px;
  color: #646566;
}
.item_status {
  margin-left: 20px;
  font-size: 15px;
  color: rgb(214, 24, 24);
}
.item_avatar_bg {
  margin: 20px 10px;
  display: flex;
  align-items: center;
}
.item_avatar_image {
  width: 80px;
  border-radius: 5px;
  cursor: pointer;
}
.item_goods_info {
  margin-left: 20px;
  width: 300px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  cursor: pointer;
  font-size: 15px;
  color: #646566;
}
.item_goods_info :hover {
  color: rgb(214, 24, 24);
}

.item_goods_num {
  margin-left: 50px;
  width: 120px;
  font-size: 15px;
}
.item_goods_total {
  flex: 1;
  text-align: left;
  margin-left: 100px;
  font-size: 17px;
  color: rgb(235, 46, 46);
}

.load_footer {
  font-size: 14px;
  text-align: center;
  color: #909399;
}
.qrcode {
  width: 150px;
  margin: 0 auto;
}
.footer {
  margin-top: 100px;
}
</style>